import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { UserResponse } from '@/types/apps/user.type';

import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface CustomerServiceGraphQLInterface {}

type CustomerAccountListResponse = GqlListResponse<UserResponse>;

export class CustomerAccountGraphQLService
    extends BaseService
    implements CustomerServiceGraphQLInterface
{
    public getEntityName(): string {
        return 'appUser';
    }

    public getFields(): Record<string, any> {
        return {
            id: true,
            fullname: true,
            email: true,
            phoneNumber: true,
            userName: true,
            createdDate: true,
            userRoles: {
                roleId: true,
            },
        };
    }

    public async index(query: string): Promise<CustomerAccountListResponse> {
        return this.fetchGqlList<CustomerAccountListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById()) {
            return {};
        }

        return {
            // getFilterByRole: {
            //     inputType: 'input',
            //     key: 'id',
            //     operator: '=',
            //     value: this.getQueryById(),
            // },
        };
    }
}
